import { render } from "./lrb.vue?vue&type=template&id=7198937e&scoped=true&ts=true"
import script from "./lrb.vue?vue&type=script&lang=ts"
export * from "./lrb.vue?vue&type=script&lang=ts"

import "./lrb.vue?vue&type=style&index=0&id=7198937e&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7198937e"]])

export default __exports__